import { useSearch } from "@tanstack/react-router";

import { EmailVerification } from "@/pages/Auth/EmailVerification";

export function EmailVerificationRouteComponent() {
  const { email } = useSearch({
    from: "/auth/email-verification",
  });

  return <EmailVerification email={email} />;
}
